export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_jdDc') || '配送中心',
    field: 'jdDc',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_jdWh') || '京东仓库',
    field: 'jdWh',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_hxJdOrderNo') || '采购单号',
    field: 'hxJdOrderNo',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_vehicle') || '运输车辆',
    field: 'vehicle',
    minWidth: 235,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'vehicle' },
  },
  {
    title: that.$l('table_label_totCtnQty') || '总箱数',
    field: 'totCtnQty',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_totCtnCbm') || '总体积',
    field: 'totCtnCbm',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
